import React from 'react';
import ModalBase from './ModalBase';
import { useTranslation } from 'react-i18next';
function CollectOrderScannerInstructionsModal({ onClose, buttonStyle }) {
    const { t } = useTranslation();

    return (
        <ModalBase>
            <div id="scannerInstructionModal">
                <div className="header">
                    <h1>{t("collectorderscanner-info-modal.header")}</h1>
                    <div className="flex scannerInstruction-container">
                        <div className="flex-col">
                            <ul className="scannerInstruction-list">
                                <li>{t("collectorderscanner-info-modal.line1")}</li>
                                <li>{t("collectorderscanner-info-modal.line2")}</li>
                                <li>{t("collectorderscanner-info-modal.line3")}</li>
                            </ul>
                            <i>{t("collectorderscanner-info-modal.footer")}</i>
                        </div>
                        <div className="flex-col">
                            <img className="scannerInstruction-image" src="/IM30QRCode.png" alt="QRCode logo"></img>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                        <button
                            onClick={onClose}
                            style={buttonStyle}
                            aria-label="Close"
                        >
                            {t("collectorderscanner-info-modal.close")}
                        </button>
                    </div>
                </div>
            </div>
        </ModalBase>
    )
}

export default CollectOrderScannerInstructionsModal
